/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../Store/Hooks";
import { providerActions } from "../../Store/Provider/reducer";
import {useFormik} from "formik";
import * as Yup from "yup";
import { selectIsProviderLoading, selectIsConfirmEmail, selectIsProviderLoggedIn } from "../../Store/Provider/selectors";
import VerifyEmail from "./Components/VerifyEmail";
import { LoginProviderFormType } from "../../Store/Provider/types";
import packageJson from '../../../package.json';
import CustomModal from "../../Components/Modals/CustomModal";
import Loader from "../../Components/Helpers/Loaders/Loader";
import { fetchDashboardList } from "../../Store/Dashboard/DashboardAPI";
import { BrowserHistory } from "../../Utils/BrowserHistory";

const initialValues: LoginProviderFormType = {email: "", password: ""}

const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAuthLoading = useAppSelector(selectIsProviderLoading);
  const isLoggedIn = useAppSelector(selectIsProviderLoggedIn);
  const isConfirmSignIn = useAppSelector(selectIsConfirmEmail);
  const [isLoading, setIsLoading] = useState<boolean>(isAuthLoading);
  const [isFocused, setIsFocused] = useState(false);
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    validationSchema: Yup.object({
      email: Yup.string().email("Please enter valid email address").required("Please enter your email"),
      password: Yup.string().required("Please enter your password"),
    }),
    onSubmit: (values) => {
      localStorage.setItem("userEmail", values.email);
      dispatch(providerActions.loginRequest(values));
    },
  });

  useEffect(()=>{
    if(isConfirmSignIn){
      resendOTP();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[isConfirmSignIn]);

  useEffect(()=>{
    if(isLoggedIn) {
      navigate("/dashboard");
      let session = sessionStorage.getItem("register");
      if(session != null){
        // fetchDashboardPatientList();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoggedIn]);

  const resendOTP = () => {
    let userNameForCode = localStorage.getItem("userEmail");
    dispatch(providerActions.resendEmailVerificationCodeRequest({username: userNameForCode!, verifyFor: "login"}));
  }

  const confirmSignIn = (otp: string) => {
    let userNameForCode = localStorage.getItem("userEmail");
    dispatch(providerActions.verifyEmail({username: userNameForCode!, code: otp, verifyFor: "login"}));
  }

  const handleVerifyPopupClose = () => {
    dispatch(providerActions.logout());
    formik.resetForm();
  }

  const fetchDashboardPatientList = async () => {
    try {
      setIsLoading(true);
      await fetchDashboardList({}).then((response: any)=>{
        if(response.success) {
          if (response.data.length > 0) {
            navigate("/dashboard");
          } else {
            BrowserHistory.replace("/dashboard");
            navigate("/addpatientleads");
          }
        } else {
          navigate("/dashboard");
        }
      }).catch((error: any) => {
        BrowserHistory.replace("/dashboard");
        navigate("/addpatientleads");
      });
    } catch (error: any) {
      BrowserHistory.replace("/dashboard");
      navigate("/addpatientleads");
    }
  }

  const handleBlur = (e: any) => {
    setIsFocused(false);
    formik.handleBlur(e);
  };

  return (
    <>
          <div className="main-wrapper onboarding-screens">
            <div className="cards-wrap card-success">
              <div className="card-body onboarding-model">
                <div className="header">
                  <div className="logo mb-4">
                    <SVG
                      className="header-logo"
                      src="Assets/Images/Logos/kiddo.svg"
                      width="108"
                      height="32"
                    />
                  </div>
                 {!isConfirmSignIn && 
                  <>
                    <h1 className="title-medium text-center">Login</h1>
                    <p className="header-text">
                      {/* View your patient's vital signs at a glance */}
                    </p>
                  </>} 
                </div>
                <div className="card-inner create-account position-relative">
                  <form className="" onSubmit={e => {
                    e.preventDefault()
                    formik.handleSubmit()
                    return false
                  }}
                  noValidate>
                    <div className="floating-input-container">
                      <input
                        placeholder=" "
                        name="email"
                        className="form-control"
                        type="email"
                        autoComplete="off"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      <label className="float-label" htmlFor="">Email</label>
                      {formik.touched.email && !formik.errors.email &&
                        <span className="tick-validate right-position">
                          <SVG
                            className="tick-icon"
                            src="Assets/Images/Icons/tick-icon.svg"
                            width="16"
                            height="16"
                          />
                        </span>}
                      {formik.touched.email && formik.errors.email ? <label className="text-error">{formik.errors.email}</label> : ""}
                    </div>
                   
                      <div className="floating-input-container mt-4">
                        <div className={`password-inner-field ${isFocused || formik.values.password ? 'focused' : ''}`} style={{ ...{ borderColor: isFocused ? "#66CFC8" : "#C4C4C4" } }}>
                              <input
                                placeholder=" "
                                onFocus={() => setIsFocused(true)}
                                onBlur={(e:any) => handleBlur(e)}
                                name="password"
                                className="form-control"
                                type="password"
                                autoComplete="off"
                                onChange={formik.handleChange}
                                // onBlur={formik.handleBlur}
                              />
                        </div> 
                        <label className="float-label" htmlFor="">Password</label>
                        {formik.touched.password && formik.errors.password ? <label className="text-error">{formik.errors.password}</label> : ""}
                     
                    </div>
                    <div className="form-group theme-color text-end forgotpassword-link">
                      <Link to={"/forgotpassword"} className="theme-color">
                        Forgot Password?
                      </Link>
                    </div>
                    <div className="form-group btn-wrap">
                      <button type="submit" className={`btn ${!formik.isValid ? "btn-custom-disabled" : "btn-success"}`} disabled={!formik.isValid} >Login</button>
                    </div>
                  </form>
                  {/* <div className="text-center mt-2">
                    <p className="theme-color">
                      Don’t have an account?{" "}
                      <Link to={"/signup"} className="theme-color">
                        Sign up
                      </Link>{" "}
                      here.
                    </p>
                  </div> */}
                  <div className="text-center mt-2">
                    <p className="theme-color">
                      &#169; Kiddo Health Inc. | Version: {packageJson.version}
                    </p>
                  </div>
                </div>
                {isConfirmSignIn && (
                  <CustomModal
                    show={isConfirmSignIn}
                    CloseContent={handleVerifyPopupClose}
                    BodyContent={() =>
                      <>
                      <div className="header w-100 justify-content-center">
                        <div className="text-center">
                          <div className="logo mb-4 text-center">
                            <SVG
                              className="header-logo"
                              src="Assets/Images/Logos/kiddo.svg"
                              width="108"
                              height="32"
                            />
                          </div>
                          <h1 className="title-medium text-center theme-color fs-5 mb-3">
                          Verification
                          </h1>
                          <p className="header-text mb-5">
                            {`Verification code has been sent to ${localStorage.getItem("userEmail")}`}
                          </p>
                        </div>
                      </div>
                        <VerifyEmail
                        onResendOTP={resendOTP}
                        onSubmitOTP={confirmSignIn}
                        isInitialSendCode={true}
                        loading={isAuthLoading}
                        key={1}
                        />
                       </>
                       }
                    closeButton={true}
                    customClass="verify-otp-padding"
                  />
                )}
                {isAuthLoading && <Loader />}
              </div>
            </div>
          </div>
      {/* {isLoggedIn && <Navigate to={"/dashboard"} />} */}
    </>
  );
};

export default Login;
